import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { toast } from 'react-toastify';
import Modal from '../../../_common/Modal/Modal';
import accountHelpers from '../../../../utils/accountHelpers';
import classes from './faxModal.module.scss';
import InputField from '../../../_common/Form/TextFields/InputField';
import { getScriptsRequest } from '../../../../store/actions/script';
import SortpakLogo from '../../../../assets/icons/sortpak-logo-fax.png';
import Loader from '../../../_common/Loader/Loader';
import Button from '../../../_common/Form/Buttons/Button';
import utils from '../../../../utils/utils';
import api from '../../../../api/api';
import { getRefillsRequest } from '../../../../store/actions/refills';
import { useQuery } from '../../../../utils/hooks/useQuery';

const info = [
  'ALL ABOVE SCRIPTS ARE AUTHORIZED FOR ______ ADDITIONAL REFILLS',
  'SCRIPTS ARE INDIVIDUALLY AUTHORIZED IN THE ABOVE LIST',
  'NOT AUTHORIZED. PATIENT NEEDS TO CALL DOCTORS OFFICE',
];

const FaxModal = ({
  modalData, onClose, status,
}) => {
  const dispatch = useDispatch();
  const scriptData = useSelector((store) => store.script.scriptData);
  const { query } = useQuery();

  const [loading, setLoading] = useState(true);
  const [loadBtn, setLoadBtn] = useState({
    preview: false,
    fax: false,
  });
  const [script, setScript] = useState([]);
  const [comment, setComment] = useState('');
  const [fax, setFax] = useState('');

  const addressPatient = _.compact([scriptData[0]?.Patient?.addressCity,
    scriptData[0]?.Patient?.addressState,
    scriptData[0]?.Patient?.addressZipCode]);

  const addressPhysician = _.compact([scriptData[0]?.Physician?.addressCity,
    scriptData[0]?.Physician?.addressState,
    scriptData[0]?.Physician?.addressZipCode]);

  const allScript = scriptData.map((p) => p);
  const isCheckedAllScript = allScript.every((data) => !!script.find((s) => data.id === s?.id));

  useEffect(() => {
    if (!_.isEmpty(modalData)) {
      (async () => {
        setLoading(true);

        await dispatch(getScriptsRequest({
          userId: accountHelpers.getUser().id,
          patientId: modalData.patientId,
          physicianId: modalData.physicianId,
          status,
          limit: 100,
        }));

        setLoading(false);
      })();
    }
  }, [modalData]);

  useEffect(() => {
    setFax(scriptData[0]?.Physician?.fax);
  }, [scriptData]);

  const onKeyPress = (e, isPaste) => {
    utils.keyPressPhoneNumber(e, isPaste);
  };

  const changeCheckbox = (check, id) => {
    if (id === 'all') {
      if (isCheckedAllScript) {
        setScript([]);
      } else {
        setScript(allScript);
      }
    } else if (script.some((s) => s.id === id)) {
      setScript(script.filter((s) => s.id !== id));
    } else {
      setScript([...script, ...scriptData.filter((s) => s.id === id)]);
    }
  };

  const changeData = (value, type) => {
    if (type === 'fax') {
      setFax(value);
    } else {
      setComment(value);
    }
  };

  const downloadFaxPgf = async (e) => {
    e.preventDefault();

    const input = document.getElementById('divToPrint');

    setLoadBtn((prev) => ({ ...prev, preview: true }));

    await html2canvas(input, {
      scale: '3',
    })
      .then((canvas) => {
        const pdf = new jsPDF();
        pdf.addImage(canvas, 'JPEG', 0, 0, 200, 300);
        pdf.save('Fax_Preview.pdf');
      });

    setLoadBtn((prev) => ({ ...prev, preview: false }));
  };

  const sendFax = async () => {
    if (_.isEmpty(script)) {
      toast.error('Fax has 0 scripts attached, please check the document');
      return;
    }

    setLoadBtn((prev) => ({ ...prev, fax: true }));

    try {
      const input = document.getElementById('divToPrint');

      const canvas = await html2canvas(input, {
        scale: '3',
      });

      const pdf = new jsPDF();
      pdf.addImage(canvas, 'JPEG', 0, 0, 200, 300);

      const receipt = pdf.output('blob');

      const formData = new FormData();

      formData.append('attachmentFile', receipt);

      const fileName = `fax-${Date.now()}.pdf`;

      toast.success(`Sending Fax to ${fax}`);

      await api.sendInsuranceFile({
        formData,
        fileName,
        faxes: true,
        scriptId: script[0].id,
      });

      const { data } = await api.uploadRefileFax(fileName, fax, formData);

      if (data === 'Access Denied') {
        toast.error('Access Denied!');
      } else {
        const date = moment().format('YYYY-MM-DD');

        for (let i = 0; i < script.length; i += 1) {
          const faxNumber = Number.isNaN(+script[i].faxNum) ? 0 : +script[i].faxNum;

          await api.scriptFaxUpload({
            id: script[i].id,
            faxNum: +faxNumber + 1,
            lastFaxed: date,
            manual: true,
          });
        }

        toast.success('Fax successfully sent');

        await dispatch(getRefillsRequest({
          status: query.status || 'Refill',
          textSearch: query.textSearch || '',
          rep: query.rep || '',
          spec: query.spec || '',
          page: query.page || 1,
          limit: query.limit || 15,
          userId: accountHelpers.getUser().id,
        }));

        onClose();
      }
      // } else {
      //   toast.error('Your fax was not send successfully');
      // }
    } catch (e) {
      const message = e.response?.data?.error?.message;
      toast.error(message || 'Unable to send a fax. Please contact your administrator.');
    }

    setLoadBtn((prev) => ({ ...prev, fax: false }));
  };

  return (
    <Modal
      onClose={onClose}
      open={!_.isEmpty(modalData)}
      className={classes.modal_wrapper}
    >

      {loading
        ? <Loader />

        : (
          <div>
            <div className={classes.wrapper}>
              <div className={classes.input_wrapper}>
                <div>
                  <InputField
                    label="Fax Number"
                    value={fax}
                    onChange={(value) => changeData(value, 'fax')}
                    onKeyPress={(e) => onKeyPress(e)}
                    onPaste={(e) => onKeyPress(e, true)}
                  />
                </div>

                <div>
                  <InputField
                    label="Comments"
                    value={comment}
                    textareaField
                    onChange={(value) => changeData(value, 'comment')}
                  />
                </div>
              </div>

              <div className={classes.table}>
                <table>

                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          onChange={(e) => changeCheckbox(e.target.checked, 'all')}
                          checked={isCheckedAllScript}
                        />
                      </th>

                      <th>Refill On</th>

                      <th>Medication</th>

                      <th>Physician</th>

                      <th>Group</th>
                    </tr>
                  </thead>

                  <tbody>
                    {scriptData.map((s) => (
                      <tr key={s.id}>
                        <td>
                          <input
                            type="checkbox"
                            onChange={(e) => changeCheckbox(e.target.checked, s.id)}
                            // checked={scriptIds.includes(s.id)}
                            checked={!!script.find((data) => data.id === s.id)}
                          />
                        </td>

                        <td>{moment(s.processedOn).format('MM/DD/YYYY')}</td>

                        <td>{s.Product.name}</td>

                        <td>{`${s.Physician?.firstName} ${s.Physician?.lastName}`}</td>

                        <td>{s.Physician?.group ? s.Physician?.group : '-'}</td>
                      </tr>
                    ))}

                  </tbody>
                </table>
              </div>

            </div>

            <h2>FAX PREVIEW</h2>

            <div
              className={classes.wrapper}
              id="divToPrint"
              style={{
                width: '210mm',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontWeight: 'bold',
                background: '#FFFFFF',
              }}
            >
              <div className={classes.logo}>
                <img
                  alt="SortPak"
                  src={SortpakLogo}
                />
                <h3>Refill Authorization Request</h3>
                <p>{`Sent on ${moment().format('MM/DD/YYYY')}`}</p>
                <p>Please utilize electronic prescribing when possible.</p>
              </div>

              <ul className={classes.address}>
                <li>655 N Central Ave 22nd Floor</li>
                <li>Glendale, Ca 91203</li>
                <li>TEL: (877) 570-7787</li>
                <li>FAX: (877) 475-2382</li>
              </ul>

              <div className={classes.table_info}>
                <table>

                  <thead>
                    <tr>
                      <th>Patient name</th>

                      <th>Date of birth</th>

                      <th>Phone</th>

                      <th>Address</th>
                    </tr>
                  </thead>

                  <tbody>

                    <tr>

                      <td>{`${scriptData[0].Patient.firstName} ${scriptData[0].Patient.lastName}`}</td>

                      <td>{moment(scriptData[0].Patient.dob).format('MM/DD/YYYY')}</td>

                      <td>{scriptData[0].Patient.phone}</td>

                      <td>
                        {scriptData[0].Patient?.addressStreet ? `${scriptData[0].Patient.addressStreet},` : ''}
                        <br />
                        {!_.isEmpty(addressPatient) && addressPatient.join(', ')}
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>

              <div className={classes.table_info}>
                <table>

                  <thead>
                    <tr>
                      <th>Physician name</th>

                      <th>Phone</th>

                      <th>Fax</th>

                      <th>Address</th>
                    </tr>
                  </thead>

                  <tbody>

                    <tr>
                      <td>{`${scriptData[0].Physician.firstName} ${scriptData[0].Physician.lastName}`}</td>

                      <td>{scriptData[0].Physician.phone}</td>

                      <td>{scriptData[0].Physician.fax}</td>

                      <td>
                        {scriptData[0].Physician?.addressStreet ? `${scriptData[0].Physician.addressStreet},` : ''}
                        <br />
                        {!_.isEmpty(addressPhysician) && addressPhysician.join(', ')}
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>

              <div className={classes.table}>
                <table>

                  <thead>
                    <tr>

                      <th>Rx number</th>

                      <th>Medication</th>

                      <th>QTY</th>

                      <th>Last Fill</th>

                      <th>Directions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {script.map((s) => (
                      <tr key={s.id}>

                        <td>{s.rxNumber}</td>

                        <td>{s.Product.name}</td>

                        <td>{s.quantity}</td>

                        <td>{s.lastFill ? moment(s.lastFill).format('MM/DD/YYYY') : '-'}</td>

                        <td>{s.directions}</td>

                      </tr>
                    ))}

                  </tbody>
                </table>
              </div>

              <div className={classes.table}>
                <table>

                  <thead>
                    <tr>
                      <th>Please check one</th>

                      <th>Doctors Remarks</th>
                    </tr>
                  </thead>

                  <tbody>
                    {info.map((i, index) => (
                      <tr key={i} className={classes.table_info_checkbox}>
                        <td>
                          <div>
                            <input type="checkbox" />

                            <p>{i}</p>
                          </div>
                        </td>

                        {index === 0 && <td rowSpan={3}>{comment}</td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className={classes.signature}>
                <p>AUTHORIZED BY</p>

                <p>__________________________</p>

                <p>SIGNATURE</p>

                <p>__________________________</p>

                <p>DATE</p>

                <p>_________________________</p>
              </div>

              <div className={classes.confidentiality}>
                <h5>CONFIDENTIALITY NOTICE</h5>

                <p>
                  The information contained in this transmittal belongs to SortPak Pharmacy and may
                  include information that is confidential, privileged, and protected
                  from disclosure under applicable law.
                  It is intended only for the use of the above physicians. If you are not the intended
                  recipient of this information,
                  you are hereby notified that any disclosure, copying, or distribution of this
                  information is strictly prohibited. If you have received this transmittal in error,
                  please immediately notify us by telephone at (877) 570-7787.
                  Thank you. Please utilize electronic prescribing when possible.
                </p>
              </div>

            </div>

            <div
              className={classes.btn_wrapper}
            >
              <Button
                onClick={onClose}
                clearButton
                title="Cancel"
                type="button"
                className={classes.btn}
              />

              <Button
                onClick={downloadFaxPgf}
                title="Preview"
                type="button"
                className={classes.btn}
                loading={loadBtn.preview}
              />

              <Button
                onClick={sendFax}
                reverseColor
                title="Send Fax"
                type="button"
                className={classes.btn}
                loading={loadBtn.fax}
              />
            </div>
          </div>
        )}
    </Modal>
  );
};

FaxModal.propTypes = {
  modalData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

export default FaxModal;
